import React, { forwardRef, useState, useRef, useEffect } from 'react'
import { X } from 'lucide-react'
import Button from 'components/Button'

export interface Props {
	className?: string
	myPartners: { name: string }[]
	handleAutocomplete: any
	handleCloseNewChat: Function
}

const ChatAddressBar = forwardRef(
	({ className = '', myPartners, handleAutocomplete, handleCloseNewChat }: Props, ref) => {
		const [inputValue, setInputValue] = useState('')
		const [selectedPartners, setSelectedPartners] = useState<any[]>([])
		const [showSuggestions, setShowSuggestions] = useState(false)
		const wrapperRef = useRef<HTMLDivElement>(null)

		console.log(`myPartners: `, myPartners)
		if (!myPartners) return null

		const filteredPartners = myPartners.filter((p: any) => {
			const name = p.partner?.name || ''
			return (
				name.toLowerCase().includes(inputValue.toLowerCase()) &&
				!selectedPartners.some((sp: any) => sp.partner?.name === name)
			)
		})

		const handleSelect = (partner: any) => {
			const newSelected = [...selectedPartners, partner]
			setSelectedPartners(newSelected)
			setInputValue('')
			setShowSuggestions(false)
			// Mimic MUI Autocomplete onChange signature: (event, value)
			handleAutocomplete(null, newSelected)
		}

		const handleRemove = (index: number) => {
			const newSelected = selectedPartners.filter((_, i) => i !== index)
			setSelectedPartners(newSelected)
			handleAutocomplete(null, newSelected)
		}

		return (
			<div
				data-testid="ChatAddressBar"
				className={`flex gap-2 justify-between items-center mb-4 pb-2 border-b border-gray-200 ${className}`}
			>
				<div className="flex-1 relative">
					<label className="text-xs text-gray-500 mb-1 block">To</label>
					<div className="flex flex-wrap gap-1 items-center border border-gray-300 rounded-md px-2 py-1 focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent">
						{selectedPartners.map((partner: any, index: number) => (
							<span
								key={index}
								className="inline-flex items-center gap-1 bg-blue-100 text-blue-800 text-xs px-2 py-0.5 rounded-full"
							>
								{partner.partner?.name}
								<button
									type="button"
									onClick={() => handleRemove(index)}
									className="hover:text-blue-600"
									aria-label="Remove partner"
								>
									<X className="w-3 h-3" />
								</button>
							</span>
						))}
						<input
							ref={ref as React.Ref<HTMLInputElement>}
							className="flex-1 min-w-[120px] outline-none text-sm py-1 bg-transparent"
							value={inputValue}
							onChange={e => {
								setInputValue(e.target.value)
								setShowSuggestions(true)
							}}
							onFocus={() => setShowSuggestions(true)}
							placeholder={selectedPartners.length === 0 ? 'Search partners...' : ''}
						/>
					</div>
					{showSuggestions && inputValue && filteredPartners.length > 0 && (
						<ul className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-48 overflow-y-auto">
							{filteredPartners.map((partner: any, index: number) => (
								<li
									key={index}
									className="px-3 py-2 text-sm hover:bg-blue-50 cursor-pointer"
									onClick={() => handleSelect(partner)}
								>
									{partner.partner?.name}
								</li>
							))}
						</ul>
					)}
				</div>
				<div>
					<Button
						className="m-0 p-2"
						type="submit"
						variant="ghost"
						onClick={handleCloseNewChat}
						aria-label="Start new chat"
					>
						<X className="w-6 h-6 text-black m-0" />
					</Button>
				</div>
			</div>
		)
	},
)

export default ChatAddressBar
